'use strict';
// core version + modules:
import Swiper, { Navigation } from 'swiper';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';


const SliderSingle = {
    els: null,
    init: function () {
        SliderSingle.els = document.querySelectorAll('.f-slider.single--');
        if (SliderSingle.els && SliderSingle.els.length > 0) {
            SliderSingle.els.forEach(el => {
                SliderSingle.create(el);
            });
            SliderSingle.zoomOnClick(SliderSingle.els);
        }
    },
    create: function (el) {
        const slider = el.querySelector('.swiper');

        let swiper = null;
        let modules = "";
        let navigation = null;

        if (slider.dataset.navigation === "fleches") {
            swiper = new Swiper(slider, {
                modules: [Navigation],
                slidesPerView: 1.5,
                spaceBetween: 20,
                loop: true,
                centeredSlides: true,
                speed: 600,
                navigation: {
                    prevEl: ".f-slider__navigation-prev",
                    nextEl: ".f-slider__navigation-next",
                },
                breakpoints: {
                    991: {
                        spaceBetween: 30,
                        slidesPerView: 3.2,
                    }
                }
            });
        }
    },
    zoomOnClick: function (slider) {
        const visualZoomContainer = document.querySelector('.f-slider__clicked')
        const visuals = slider[0].querySelectorAll('.c-img img');
        let img = null;
        if (visuals.length > 0 && visualZoomContainer) {
            const imgContainer = visualZoomContainer.querySelector('.f-slider__clicked-img');
            if (imgContainer) {
                img = document.createElement("img");
                img.setAttribute("src", visuals[0].getAttribute('src'));
                img.setAttribute("alt", visuals[0].getAttribute('alt'));
                imgContainer.appendChild(img)
            }
            const closeBtn = visualZoomContainer.querySelector('.close-btn');
            if (closeBtn) {
                closeBtn.addEventListener('click', () => {
                    visualZoomContainer.classList.remove('open')
                })
            }
            visuals.forEach(visual => {
                visual.addEventListener('click', (e) => {
                    visualZoomContainer.classList.add('open');
                    if (img) {
                        img.setAttribute("src", e.target.getAttribute('src'));
                        img.setAttribute("alt", e.target.getAttribute('alt'));
                    }
                })
            })
        }
    }
};

export default SliderSingle;